import { QueryClient } from "@tanstack/react-query";

// This is global to all components that import it, including any cached
// response data.
export const queryClient = new QueryClient();
